import React, { useEffect, useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { motion } from "framer-motion";
import { fadeIn } from "../variants";
import { CiLinkedin } from "react-icons/ci";
import { FaGithub } from "react-icons/fa";

const Contact = () => {
  const formRef = useRef();
  const [error, setError] = useState(false);
  const [Success, setSuccess] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_5612vfm", "template_03r6qtg", formRef.current, {
        publicKey: "ZRBpe_F3HDIzQmVsM",
      })
      .then(
        (result) => {
          setError(true);
        },
        (error) => {
          setError(true);
        }
      );
  };

  return (
    <section className="py-16 lg:section" id="contact">
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row">
          <motion.div
            variants={fadeIn("right", 0.3)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.3 }}
            className="flex-1 flex justify-start items-center"
          >
            <div>
              <h4 className="text-xl uppercase text-accent font-medium mb-2 tracking-wide">
                Get In Touch
              </h4>
              <h2 className="text-[45px] lg:text-[80px] leading-none mb-2">
                lets work <br /> together
              </h2>
              <div className="flex  gap-4 items-end mb-5">
                <a
                  target="_blank"
                  href="https://www.linkedin.com/in/akash-gauda-3b106b237/"
                >
                  <CiLinkedin />
                </a>
                <a target="_blank" href="https://github.com/gaudakash">
                  <FaGithub />
                </a>
              </div>
            </div>
          </motion.div>
          <motion.form
            id="form-data"
            ref={formRef}
            onSubmit={sendEmail}
            variants={fadeIn("left", 0.3)}
            initial="hidden"
            whileInView={"show"}
            viewport={{ once: false, amount: 0.3 }}
            action=""
            className="flex-1 border rounded-2xl flex flex-col gap-y-6 p-6 h-[50vh] items-start"
          >
            <input
              id="Name"
              type="txt"
              required
              placeholder="Name"
              name="name"
              className="bg-transparent border-b py-3 outline-none w-full"
            />
            <input
              id="email"
              type="email"
              className="bg-transparent border-b py-4 outline-none w-full"
              required
              placeholder="Email"
              name="email"
            />
            <textarea
              id="msg"
              placeholder="Hire Me / any Work For Me"
              rows="{8}"
              className="bg-transparent border-b py-1 outline-none w-full"
              name="message"
            ></textarea>
            <button className="btn contact-form-btn">Send message</button>
            {Success && "Success"} {error && "error"}
          </motion.form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
